export const ChartIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <g>
        <rect x="1" y="1" width="22" height="17" />
        <path d="M12 18.5V22M8 23H16" />
        <path d="M1 10.5H6.30769C7.24233 10.5 8 9.74233 8 8.80769V7C8 5.89543 8.89543 5 10 5V5C11.1046 5 12 5.89543 12 7V12C12 13.1046 12.8954 14 14 14V14C15.1046 14 16 13.1046 16 12V10.8846C16 10.1199 16.6199 9.5 17.3846 9.5H23" />
      </g>
    </svg>
  );
};
